/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class WorkflowHoverContext {

        public workflowBlock: IWorkflowBlock;
        public workflowBlockHovered: boolean;
        public deleteOptionHovered: boolean;
        public settingsOptionHovered: boolean;
        public inBetweenDropZoneHovered: boolean;
        public inBetweenIndex: number;
        public inBetweenFromWorkflowBlock: IWorkflowBlock;
        public inBetweenToWorkflowBlock: IWorkflowBlock;

        constructor(
            workflowBlock: IWorkflowBlock,
            workflowBlockHovered: boolean,
            deleteOptionHovered: boolean,
            settingsOptionHovered: boolean,
            inBetweenDropZoneHovered?: boolean,
            inBetweenIndex? : number,
            inBetweenFromWorkflowBlock?: IWorkflowBlock,
            inBetweenToWorkflowBlock?: IWorkflowBlock
        )
        {
            this.workflowBlock = workflowBlock;
            this.workflowBlockHovered = workflowBlockHovered;
            this.deleteOptionHovered = deleteOptionHovered;
            this.settingsOptionHovered = settingsOptionHovered;
            this.inBetweenDropZoneHovered = inBetweenDropZoneHovered;
            this.inBetweenIndex = inBetweenIndex;
            this.inBetweenFromWorkflowBlock = inBetweenFromWorkflowBlock;
            this.inBetweenToWorkflowBlock = inBetweenToWorkflowBlock;
        }
    }
}